import styled from 'styled-components';
import { Button, Dialog, DialogActions, DialogTitle } from '@material-ui/core';

export const Container = styled(Dialog)`
  && {
    z-index: 6000;
  }

  .MuiDialog-paper {
    width: calc(100% - 32px);
    max-width: 420px;
    border-radius: 8px;
  }
`;

export const Title = styled(DialogTitle)`
  && {
    padding: 24px 24px 8px;
  }
`;

export const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  color: #1f2937;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.35;
`;

export const Message = styled.p`
  margin: 0;

  color: #4b5563;
  font-size: 0.95rem;
  line-height: 1.5;
`;

export const Actions = styled(DialogActions)`
  && {
    padding: 8px 24px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const CloseButton = styled(Button)`
  && {
    min-width: 96px;

    background-color: #007467;
    color: #ffffff;
    text-transform: none;
  }

  &&:hover {
    background-color: #00665a;
  }
`;
